<template>
  <div class="out">
    <div class="headerOut">
      <div class="left">
        <img src="@/assets/images/logo.png" @click="goHome" />
        <img src="@/assets/images/subLogo.png" @click="goCloud" />
        <div v-if="isLogin">用户中心</div>
      </div>
      <ul class="menu">
        <li
          class="hoverClass"
          @click="handleSelect"
          data-type="index"
          :class="{ active: current == 'index' }"
        >
          首页
        </li>
        <li
          class="hoverClass"
          @click="handleSelect"
          data-type="tools"
          :class="{ active: current == 'tools' }"
        >
          云分析
        </li>
        <li
          class="hoverClass"
          @click="handleSelect"
          data-type="videos"
          :class="{ active: current == 'videos' }"
        >
          培训视频
        </li>
        <li style="cursor:default">
          <el-popover
            popper-class="myPopover"
            placement="bottom"
            width="120"
            trigger="hover"
          >
            <!-- 这里是触发元素 -->
            <template #reference>
              <div class="inline">
                <div>LinkMed</div>
                <div class="linkmed-marquee" v-if="linkMedIntro != ''">
                  <div class="marquee-content">
                    <span>{{ linkMedIntro }}</span>
                    <span>{{ linkMedIntro }}</span>
                  </div>
                </div>
              </div>
            </template>
            <div class="headPopOut">
              <div class="menu">
                <a href="https://linkmed.cc/linkmed/#/auth?ref=AAAAAAAAG60" target="_blank">
                  <div>官方链接</div>
                </a>
                <router-link to="/viewDocument" onclick="event.stopPropagation();">
                  <div>帮助文档</div>
                </router-link>
              </div>
            </div>
          </el-popover>
        </li>
        <li
          class="hoverClass"
          @click="handleSelect"
          data-type="news"
          :class="{ active: current == 'news' }"
        >
          新闻中心
        </li>        
        <li
          v-if="!isLogin"
          @click="handleSelect"
          data-type="login"
          class="hoverClass"
          :class="{ active: current == 'login' }"
        >
          登录
        </li>
        <li
          v-if="!isLogin"
          @click="handleSelect"
          data-type="regedit"
          class="hoverClass"
          :class="{ active: current == 'regedit' }"
        >
          注册
        </li>
        <li
          v-if="isLogin"
          data-type="login"
          :class="{ active: current == 'login' }"
          @click="toOverview"
        >
          <div class="info">
            <el-popover
              popper-class="myPopover"
              placement="bottom"
              :width="140"
              trigger="hover"
              @show="onPopoverShow"
              @hide="onPopoverHidden"
            >
              <!-- 这里是触发元素 -->
              <template #reference>
                <div>
                  <img :src="
                      avatar.length > 0
                        ? avatar
                        : require('@/assets/images/noavatar_middle.gif')
                    "
                  />
                  <div>{{ username }}</div>
                  <el-icon class="down">
                    <svg-icon type="down_arrow" :class="{'upArrow': !iconIsDown}"/>
                  </el-icon>
                </div>
              </template>
              <div class="headPopOut">
                <div class="menu">
                  <!-- 注意：此处的父节点<li class="info">有点击事件，为了在点击router-link不让事件冒泡到父节点，所以此处使用了event.stopPropagation() -->
                  <router-link to="/user/overview" onclick="event.stopPropagation();">
                    <div>
                      <svg-icon type="overview" />
                      信息总览
                    </div>
                  </router-link>
                  <router-link to="/user/info" onclick="event.stopPropagation();">
                    <div>
                      <svg-icon type="myinfo" />
                      个人信息
                    </div>
                  </router-link>
                  <router-link to="/user/projects" onclick="event.stopPropagation();">
                    <div>
                      <svg-icon type="myprojects" />
                      我的项目
                    </div>
                  </router-link>
                  <router-link to="/user/datas" onclick="event.stopPropagation();">
                    <div>
                      <svg-icon type="mydatas" />
                      我的数据
                    </div>
                  </router-link>
                  <router-link to="/user/collection" onclick="event.stopPropagation();">
                    <div>
                      <svg-icon type="favorites" />
                      我的收藏
                    </div>
                  </router-link>
                  <router-link to="/user/notice" onclick="event.stopPropagation();">
                    <div>
                      <svg-icon type="notice" />
                      消息中心
                    </div>
                  </router-link>
                  <!-- <div>
                    <svg-icon type="invoice" />
                    我的发票
                  </div> -->
                </div>
                <div class="exit" @click="exit">
                  <svg-icon type="exit" />
                  退出
                </div>
              </div>
            </el-popover>
          </div>
        </li>
        <li class="gotoMessage" v-if="isLogin" @click="toMessageCenter">
          <div class="message">
            <svg-icon type="bell" />
            <div class="nums" v-if="unreadMessageNums != 0 && !Number.isNaN(unreadMessageNums)">{{unreadMessageNums}}</div>
          </div>
        </li>
        <li id="lng"><span class="active" @click="changeLang('cn')">中文</span>｜<span @click="changeLang('en')">English</span></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, reactive, toRefs, watch } from "vue";
import { useRouter } from "vue-router";
import { cache, clearLogin } from "@/config";
import { logout } from "@/api/user/index";
import { ElMessageBox } from "element-plus";
import store from "@/store";
import { linkMedIntro } from "@/../public/config"

export default defineComponent({
  name: "HeaderLayer",
  props: {
    menuType: {
      //注意：此处必须定义，否则setup的props.menuType打印时为undefined
      type: String,
      default: "",
    },
  },
  components: { },
  setup(props) {
    const router = useRouter();
    let language = cache('language');
    let userInfo = cache("userInfo");
    const username = userInfo.UserName;
    const avatar = userInfo.Avatar;
    let current = ref(props.menuType);
    const iconIsDown = ref(false); //三角头方向，false向上，true向下

    const onPopoverShow = () => { 
      iconIsDown.value = true;
    };

    const onPopoverHidden = () => { 
      iconIsDown.value = false;
    };

    let isLogin = ref(false); //是否已经登录，用于是否显示个人信息，默认为未登录
    //如果已经登录的，显示用户信息
    if (userInfo) {
      isLogin.value = true;
    }

    let state =  reactive({
      unreadMessageNums: 0
    })

    watch(() => store.getters.getUnreadMessageNums, //监视store的参数
      (newValue/*, oldValue*/) => {
        state.unreadMessageNums = newValue;
        // console.log(newValue, oldValue)
      },
      { immediate: true }
    );

    const toMessageCenter = () =>{
      router.push({
        path: "/user/notice",
      });
    }
    
    onMounted(async () => {
      store.commit('countUnreadMessageNums');
      // store.dispatch('countUnreadNoticeNumsAsyn');
    });

    const changeLang = (lang) => {
      store.commit('setLang', lang);
      language = cache('language');

      //匹配以En结尾的字符串，如：ToolsViewEn
      let reg = new RegExp("\\w*En$", 'ig');
      let currentRouteName = router.currentRoute._value.name;
      let matchResult = reg.test(currentRouteName);
      if(language == '' || language == 'cn'){
        if(matchResult){ //如果是中文状态的，但当前路由名称又是英文的，将英文地址改成中文地址
          router.push({
            name: currentRouteName.replace('En', '')
          });
        }
      }else{
        if(!matchResult){ //如果是英文状态的，但当前路由名称又是中文的，将中文地址改成英文地址
          router.push({
            name: currentRouteName + 'En'
          });
        }
      }
    }

    const exit = (e) => {
      e.stopPropagation(); //阻止事件冒泡
      e.preventDefault(); //阻止元素的默认行为
      ElMessageBox.confirm("您确定退出吗？", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: 'btnConfirm',
        cancelButtonText: "取消"
      })
        .then(async () => {
          await logout({lang: language}); //先清除服务器上的缓存
          await clearLogin(); //再清除本地浏览器缓存
          isLogin.value = false;
          goHome();
        })
        .catch(() => {});
    };

    const handleSelect = (event) => {
      let type = event.currentTarget.dataset.type;
      switch (type) {
        case "index":
          // 跳转
          router.push({
            path: "/",
          });
          current = "index";
          break;
        case "tools":
          router.push({
            path: "/tools",
          });
          current = "tools";
          break;
        case "videos":
          router.push({
            path: "/videos",
          });
          current = "videos";
          break;
        case "news":
          router.push({
            path: "/news",
          });
          current = "news";
          break;
        case "login":
          router.push({
            path: "/user/login",
          });
          current = "login";
          break;
        case "regedit":
          router.push({
            path: "/user/regedit",
          });
          current = "regedit";
          break;
        default:
          break;
      }
    };

    const goHome = () => {
      let path = router.currentRoute.path;
      if (path !== "/") {
        router.push({
          path: "/",
        });
      }
    };

    const goCloud = () => {
      let path = router.currentRoute.path;
      if (path !== "/") {
        router.push({
          path: "/tools",
        });
      }
    }

    const toOverview = (event) => { //信息总览页面
      event.preventDefault();
      event.stopPropagation();
      router.push({
        name: "MyOverview",
      });
    }

    return {
      linkMedIntro,
      iconIsDown,
      onPopoverShow,
      onPopoverHidden,
      goHome,
      goCloud,
      current,
      handleSelect,
      isLogin,
      exit,
      username,
      avatar,
      ...toRefs(state),
      toMessageCenter,
      changeLang,
      toOverview
    };
  }
});
</script>

<style lang="less" scoped>
* {
  font-size: 1.12rem;
}
a:visited {
  color: #505050;
}
a {
  color: #505050;
  text-decoration: none;
}
.out {
  overflow: unset !important;
  padding: 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  min-width: 1410px;
}
.left {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
  height: 55px;
}
.left div {
  font-size: 1.5rem;
  margin-left: 10px;
  border-left: 1px solid #d0d1d1;
  padding-left: 10px;
  color: #000;
  height: 55px;
  line-height: 55px;
}
.left img {
  cursor: pointer;
}
ul {
  list-style-type: none;
  margin: 0;
  color: #1f1f1f;
}
li {
  padding: 0 20px;
  position: relative;
}
.menu {
  display: flex;
  height: 75px;
  line-height: 75px;
}
.menu li.hoverClass::after {
  /*鼠标移动菜单栏动画*/
  content: "";
  height: 3px;
  overflow: hidden;
  display: block;
  left: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  background: @themeColor;
  transform: scaleX(0);
  transition: all 0.5s;
}
.menu li.hoverClass:hover::after {
  /*鼠标移动菜单栏动画*/
  transform: scaleX(1);
}
.menu li.active {
  color: @themeColor;
}
.menu li.active::after {
  color: @themeColor;
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: @themeColor;
  height: 3px;
  transform: none;
}
.menu li.hoverClass:hover {
  color: @themeColor;
  cursor: pointer;
}
.headerOut {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-width: 1200px;
  max-width: 98%;
  background-color: #fff;
  margin: 0 auto;
  align-items: flex-end;
}
.headerOut .left img {
  width: 136px;
  height: 36px;
  margin-top: 3px;
}
.headerOut .left img:first-child {
  width: 150px;
  height: 44px;
  margin-right: 10px;
  margin-top: 0;
}
.el-loading-mask {
  z-index: 5 !important;
}
.svg-icon {
  width:1.28rem !important;
  height: 1.28rem !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
li.gotoMessage{
  cursor: pointer;
}
li.gotoMessage .message {
  position: relative;
  color: #1f1f1f;
}
li.gotoMessage .message .svg-icon {
  font-size: 1.35rem;
}
li.gotoMessage .message .nums {
  border-radius: 50%;
  background-color: red;
  color: #fff;
  position: absolute;
  right: -15px;
  top: 10px;
  line-height: 19px;
  width: 19px;
  height: 19px;
  text-align: center;
  font-size: 0.9rem;
}
li#lng span{
  cursor: pointer;
}
li#lng span.active{
  color: #058B00
}
.upArrow{ 
  transform: rotate(180deg);
}
/* LinkMed 跑马灯样式 */
.inline {
  display: flex;
  align-items: center;
}
.linkmed-marquee {
  width: 150px;
  height: 35px;
  overflow: hidden;
  white-space: nowrap;
  position: relative;   /* 关键：为伪元素定位 */
  margin-left: 5px;
  background-color: #f9f9f9;
  border-radius: 35px;
  display: flex;
  align-items: center;
  /* 左侧遮挡条：制造 5px 留白 */
  /* &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 10px;
    background-color: #f9f9f9;
    z-index: 2;
    pointer-events: none;
    border-top-left-radius: 35px;
    border-bottom-left-radius: 35px;
  } */
  /* 右侧遮挡条：制造 5px 留白 */
  /* &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 10px;
    background-color: #f9f9f9;
    z-index: 2;
    pointer-events: none;
    border-top-right-radius: 35px;
    border-bottom-right-radius: 35px;
  } */
}
.marquee-content {
  display: inline-block;
  white-space: nowrap;
  flex-shrink: 0;
  animation: marquee-scroll 12s linear infinite;
  &:hover {
    animation-play-state: paused;
  }
}
.marquee-content span {
  display: inline-block;
  padding-right: 40px;
  color: @themeColor;
}
@keyframes marquee-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>